var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { HouseDetailsBaseComponent } from './../common-theme/index';
var HouseDetailsComponent = /** @class */ (function (_super) {
    __extends(HouseDetailsComponent, _super);
    function HouseDetailsComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return HouseDetailsComponent;
}(HouseDetailsBaseComponent));
export { HouseDetailsComponent };



// WEBPACK FOOTER //
// ./src/app/houses/house-details.component.ts.pre-build-optimizer.js